import { supabase } from "../supabase-client";


export interface FeedbackData {
  feedback_text: string;
  email?: string;
  category?: 'bug' | 'feature' | 'improvement' | 'general' | 'complaint';
  user_agent?: string;
  page_url?: string;
}

export const submitFeedback = async (feedbackData: FeedbackData) => {
  try {
    const {
      data: { user }
    } = await supabase.auth.getUser();

    const { data, error } = await supabase
      .from('feedback')
      .insert({
        user_id: user?.id || null,
        feedback_text: feedbackData.feedback_text,
        email: feedbackData.email || null,
        category: feedbackData.category || 'general',
        user_agent: feedbackData.user_agent || navigator.userAgent,
        page_url: feedbackData.page_url || window.location.href,
      })
      .select()
      .single();

    if (error) {
      console.error('Error submitting feedback:', error);
      return { success: false, error: error.message };
    }

    return { success: true, data };
  } catch (error) {
    console.error('Unexpected error submitting feedback:', error);
    return { success: false, error: 'An unexpected error occurred' };
  }
};